import 'gsap/TweenLite';
import 'gsap/TweenMax';

const Navigation = class Navigation {

    constructor(config) {
        this.menuTrigger = config.menuTrigger;
        this.navigationListItem = config.navigationListItem;
        this.navigationFooterItem = config.navigationFooterItem;
        this.navigation = config.navigation;
    }

    init() {

        let menuTrigger = this.menuTrigger,
            navigationItem = this.navigationListItem,
            navigationFooterItem = this.navigationFooterItem,
            navigation = this.navigation;

        let tlNav, tlNavFooter;
        tlNav = new TimelineMax({
            onReverseComplete: () => {
                TweenLite.set(navigationItem, {clearProps: "all"});
            }
        });
        tlNavFooter = new TimelineMax({
            onReverseComplete: () => {
                TweenLite.set(navigationFooterItem, {clearProps: "all"});
            }
        });
        menuTrigger.on("click", function () {
            if ($("html").hasClass("isOpen")) {

                tlNav.staggerFromTo(
                    navigationItem,
                    0.5,
                    {x: '+=0', autoAlpha: 1},
                    {
                        // y: '+=15',
                        x: '+=10',
                        autoAlpha: 0,
                        delay: 0.1,
                        ease: Back.easeOut.config(1),
                        force3D: "auto"
                    },
                    0.05
                );
                tlNavFooter.staggerFromTo(
                    navigationFooterItem,
                    0.5,
                    {y: 0, autoAlpha: 1},
                    {
                        // y: 15,
                        y: 25,
                        autoAlpha: 0,
                        delay: 0.5,
                        ease: Back.easeOut.config(1),
                        force3D: "auto"
                    },
                    0.09
                );

                $("html").removeClass("isOpen");

                setTimeout(function () {
                    $("html").addClass("isClosed");
                }, 400);
                setTimeout(function () {
                    $("html").addClass('isLoop');
                }, 885);
                setTimeout(function () {
                    $("html").removeClass('isLoop');
                }, 1600);

            } else {
                $("html").removeClass("isClosed");

                setTimeout(function () {
                    $("html").addClass("isOpen");
                    navigation.addClass("is-active");

                    tlNav.staggerFromTo(
                        navigationItem,
                        0.5,
                        {x: -10, autoAlpha: 0},
                        {
                            x: 0,
                            autoAlpha: 1,
                            delay: 0.1,
                            ease: Back.easeOut.config(1),
                            force3D: "auto"
                        },
                        0.05
                    );

                    tlNavFooter.staggerFromTo(
                        navigationFooterItem,
                        0.5,
                        {y: -25, x: 0, autoAlpha: 0},
                        {
                            y: 0,
                            x: 0,
                            autoAlpha: 1,
                            delay: 0.5,
                            ease: Back.easeOut.config(1),
                            force3D: "auto"
                        },
                        0.09
                    );
                }, 400);
            }
        });

        menuTrigger.on("click", function () {
            if (navigation.hasClass("is-active")) {
                setTimeout(function () {
                    navigation.removeClass("is-active");
                }, 890);
            } else {
                setTimeout(function () {
                    navigation.addClass("is-active");
                }, 400);
            }
        });

        menuTrigger.on("mouseenter", function () {
            $("html").addClass("isLoop");
        });
        menuTrigger.on("mouseover", function () {
            $("html").addClass("isHover");
        });
        menuTrigger.on("mouseleave", function () {
            $("html").removeClass("isLoop");
            $("html").removeClass("isHover");
        });
    }
};

export {Navigation};


// WEBPACK FOOTER //
// ./static/js/components/Navigation.js